import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class RegionService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerRegionSegunCodigo(inputParams: {
    entidad: {
      codigo: number
    }
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: regionInputType) {
          region {
            obtenerRegionSegunCodigo(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.region.obtenerRegionSegunCodigo
        callback({ mensajes, respuesta })
      }
    );
  }

}
